var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('CfsisTable',{staticClass:"pb-4",scopedSlots:_vm._u([{key:"actions",fn:function({ dataset }){return [_c('avs-exportButton',{attrs:{"data":dataset,"prepare":_vm.preFmtData,"name":_vm.$t('actions.export_'),"spantext":_vm.$t('actions.export', { entity: _vm.$tc('categories.cfsi.name', 2) })}}),_c('avs-createButton',{attrs:{"to":{ name: 'CfsiCreateUpdate' },"spantext":_vm.$t('actions.create', {
            entity: _vm.$tc('categories.cfsi.name', 1).toLowerCase()
          }),"name":_vm.$t('actions.new_female', {
            entity: _vm.$tc('categories.cfsi.name', 1).toLowerCase()
          })}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }